import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { updateUser, uploadSignature, deleteSignature } from '../../actions/profile/apiRequests';
import { fetchProfile } from '../../actions/profile/actionCreators';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import ProfilePage from './ProfilePage';

const MyProfilePage = ({
  profile,
  history,
  dispatchFetchProfile,
  ...props
}) => {
  const handleSignature =({ id }, file = null, deleted) => {
    if (file) {
      return uploadSignature(id, file);
    }

    if (deleted) {
      return deleteSignature(id);
    }

    return Promise.resolve();
  }

  const onCancel = () => {
    history.goBack();
  }

  const onSave = (user, signature, signatureDeleted) => {
    return updateUser(profile.id, user)
      .then(() => handleSignature(user, signature, signatureDeleted))
      .then(() => dispatchFetchProfile(profile.id));
  }

  return (
    <ProfilePage
      profile={profile}
      onSave={onSave}
      onCancel={onCancel}
      editEmail={true}
      {...props}
    />
  );
}

MyProfilePage.propTypes = {
  profile: PropTypes.object,
  history: PropTypes.object,
  dispatchFetchProfile: PropTypes.func,
};

const mapStateToProps = ({ profile }) => ({ profile });
const mapDispatchToProps = (dispatch) => ({
  dispatchFetchProfile: (id) => dispatch(fetchProfile(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withEulaRestrictions(withRoleRestrictions(MyProfilePage)));



// WEBPACK FOOTER //
// src/components/profile/MyProfilePage.jsx